import { render, staticRenderFns } from "./narratorSuccessPage.vue?vue&type=template&id=5ca118fa&scoped=true"
import script from "./narratorSuccessPage.vue?vue&type=script&lang=js"
export * from "./narratorSuccessPage.vue?vue&type=script&lang=js"
import style0 from "./narratorSuccessPage.vue?vue&type=style&index=0&id=5ca118fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca118fa",
  null
  
)

export default component.exports